"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipType = void 0;
// DEPRECATED
// Delete once clients move to CallLayout.tsx
var react_1 = __importStar(require("react"));
var VideoStream_1 = __importDefault(require("./VideoStream"));
var useMobile_1 = __importDefault(require("./hooks/useMobile"));
var VideoMuted_1 = __importDefault(require("./VideoMuted"));
var core_1 = require("@material-ui/core");
var constants_1 = require("./constants");
var PipType;
(function (PipType) {
    PipType["pip"] = "pip";
    PipType["pres"] = "pres";
})(PipType = exports.PipType || (exports.PipType = {}));
var mobileSmall = '12vh';
var mobileLarge = '25vh';
var desktopSmall = '86px';
var desktopLarge = '173px';
var useStyles = core_1.makeStyles(function () { return ({
    pipContainer: {
        margin: 0,
        zIndex: 10,
        display: function (props) { return (props.hidden ? 'none' : 'inherit'); },
        cursor: function (props) { return (typeof props.onClick === 'function' ? 'pointer' : 'inherit'); }
    },
    holder: {
        display: function (props) { return (props.showVideoMute ? 'none' : 'inherit'); }
    }
}); });
function Pip(props) {
    var _a = props.animate, animate = _a === void 0 ? true : _a, containerStyle = props.containerStyle, _b = props.dataTestId, dataTestId = _b === void 0 ? 'pip' : _b, displayName = props.displayName, elementId = props.elementId, mirror = props.mirror, _c = props.muted, muted = _c === void 0 ? true : _c, onClick = props.onClick, _d = props.pipType, pipType = _d === void 0 ? PipType.pip : _d, stream = props.stream, videoMuted = props.videoMuted, videoStyle = props.videoStyle;
    var _e = react_1.useState(desktopSmall), pipHeight = _e[0], setPipHeight = _e[1];
    var isMobile = useMobile_1.default().isMobile;
    var showVideoMute = videoMuted || !stream;
    var classes = useStyles(__assign(__assign({}, props), { showVideoMute: showVideoMute, pipHeight: pipHeight }));
    var getPipSmall = react_1.useCallback(function () {
        return isMobile ? mobileSmall : desktopSmall;
    }, [isMobile]);
    var getPipLarge = react_1.useCallback(function () {
        if (!animate)
            return getPipSmall();
        return isMobile ? mobileLarge : desktopLarge;
    }, [isMobile, animate, getPipSmall]);
    react_1.useEffect(function () {
        setPipHeight(getPipSmall());
    }, [getPipSmall]);
    /* for a normal pip (video stream), we are allowing the pip to assume its normal aspect ratio (it is not expected
     * that it will exceed too far beyond 16:9 (if at all) in either orientation)
     * since presentations can easily take any shape, they are set to 'cover' the designated pip space and the pip is
     * fixed to a 16:9 landscape */
    var style = __assign(__assign({}, videoStyle), { borderRadius: '.5rem', boxShadow: '-2px 2px 5px 0px rgba(.5,.5,.5,.5)', height: pipHeight, margin: "0 " + constants_1.margin + "px " + constants_1.margin + "px 0", objectFit: (pipType !== PipType.pres) ? 'contain' : 'cover', transition: 'height .5s', width: (pipType !== PipType.pres) ? 'auto' : "calc(" + pipHeight + " * " + constants_1.aspectRatio_16to9 + ")" });
    var muteStyle = __assign(__assign({}, videoStyle), { borderRadius: '.5rem', boxShadow: '-2px 2px 5px 0px rgba(.5,.5,.5,.5)', height: pipHeight, margin: "0 " + constants_1.margin + "px " + constants_1.margin + "px 0", width: "calc(" + pipHeight + " * " + constants_1.aspectRatio_16to9 + ")", zIndex: 99 });
    return (react_1.default.createElement("div", { "data-testid": dataTestId, className: classes.pipContainer, style: containerStyle, onClick: function (e) { return onClick && onClick(e); } },
        showVideoMute && react_1.default.createElement(VideoMuted_1.default, { displayName: displayName || '', style: muteStyle }),
        react_1.default.createElement("div", { className: classes.holder, onMouseEnter: function () { return setPipHeight(getPipLarge()); }, onMouseLeave: function () { return setPipHeight(getPipSmall()); } },
            react_1.default.createElement(VideoStream_1.default, { mirror: mirror, elementId: elementId, muted: muted, style: style, mediaStream: stream }))));
}
exports.default = Pip;
